import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import { createQueryKey } from '@/lib/react-query'
import CrudService from '@/services/crudService'

const resource = API_RESOURCE.SYSTEM_VARIABLE
const SystemVariableService = {
  resource,
  queryKey: createQueryKey(resource),
  ...CrudService(resource),
}

export default SystemVariableService
